import api from './base'

export default {
  getAll ({ businessUnitId, search }) {
    let url = `company/business_units/${businessUnitId}/articles`
    if (search) {
      url += `?search=${encodeURI(search)}&search_inside=true`
    }
    return api().get(url)
  },
  getAllForInventory ({ businessUnitId }) {
    return api().get(`company/business_units/${businessUnitId}/articles?inventoryKept=true`)
  },
  getById ({ businessUnitId, id, headers }) {
    if (headers != null) {
      return api().get(`company/business_units/${businessUnitId}/articles/${id}`, { headers: headers })
    } else {
      return api().get(`company/business_units/${businessUnitId}/articles/${id}`)
    }
  },
  save ({ businessUnitId, item }) {
    return api().put(`company/business_units/${businessUnitId}/articles`, item)
  },
  delete ({ businessUnitId, id }) {
    return api().delete(`company/business_units/${businessUnitId}/articles/${id}`)
  },
  setSortOrder ({ businessUnitId, articleId, sortOrder }) {
    return api().put(`company/business_units/${businessUnitId}/articles/${articleId}/sort_order`, { sort_order: sortOrder })
  }
}
